function Footer() {
    return (
        <>
            <footer>
                <p>Made with 💜 at Juno College - Milan Kozovski, Sheh Sarfraz, Tenzin Choenyi, Ambernay Trotter ©2023</p>
            </footer>
        </>
    )
}

export default Footer;